<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <div class="card bg-color-light card-ui-no-border mb-3" id="list">

      <!-- Unpublish resource from IRR modal -->
      <div class="modal fade" id="unpublishResourceModal" tabindex="-1" role="dialog" aria-labelledby="unpublishResourceModalLabel" aria-hidden="true" style="z-index: 10001;">
        <div class="modal-dialog modal-lg" role="document">
          <div v-if="unpublishResource && currentIrr" class="modal-content">
            <div class="modal-header">
              <h3 class="modal-title" id="publishModalLabel">Unpublish Resource from {{currentIrr.name}}</h3>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h5 style="color:red !important;">Are you sure you want to unpublish this resource from the registry?</h5>
              <p class="lead mt-5">
                <span class="font-weight-bold"><u>RESOURCE DETAILS:</u></span> <br />&nbsp;<br />
                <span class="font-weight-bold">Name&nbsp;&nbsp;-&nbsp;&nbsp;</span> {{unpublishResource.name}} <br />
                <span class="font-weight-bold">Contributor&nbsp;&nbsp;-&nbsp;&nbsp;</span> {{unpublishResource.user_display_name}}
              </p>
              <br>&nbsp;<br>
              <div class="checkbox">
                <label><input type="checkbox" value="" onchange="(!this.checked) ? $('#modal-unpublish-button').addClass('disabled') : $('#modal-unpublish-button').removeClass('disabled');">&nbsp;I want to unpublish this resource from the registry</label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-sm btn-danger disabled" role="button" id="modal-unpublish-button" @click="submitUnpublish">Unpublish Resource</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Copy resource to template modal -->
      <div class="modal fade" id="listCopyToTemplateModal" tabindex="-1" role="dialog" aria-labelledby="listCopyToTemplateModalLabel" aria-hidden="true" style="z-index: 10001;">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header border-0 pb-0">
              <h5 class="modal-title" id="listCopyToTemplateModalLabel">Copy to Template</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body pt-2">
              <p>Enter a name for the template in the field below. We recommend that you choose a name distinct from your resource name to avoid confusion later.</p>
              <div class="form-group mb-0">
                <input
                  type="text"
                  class="form-control"
                  id="listTemplateCopyName"
                  v-model="templateCopyName"
                  maxlength="40"
                  :class="{ 'is-invalid': templateCopyNameError }"
                  placeholder="Template name"
                  @keyup.enter.prevent="submitCopyAsTemplate"
                >
                <div v-if="templateCopyNameError" class="invalid-feedback d-block">{{ templateCopyNameError }}</div>
              </div>
            </div>
            <div class="modal-footer border-0 justify-content-start pt-0">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary ml-2" :disabled="templateCopyInProgress" @click="submitCopyAsTemplate">{{ templateCopyInProgress ? 'Copying...' : 'Copy' }}</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body card-ui-no-border bg-color-light">
        <div v-if="templateCopySuccessMessage" class="alert alert-success" role="alert">
          {{ templateCopySuccessMessage }}
          <template v-if="templateCopyId">
            <a :href="'/resource/' + templateCopyId" target="_blank" rel="noopener noreferrer">Click here</a> to view the template in a new tab.
          </template>
        </div>
        <div class="row">
          <div class="col-8">
            <h1 v-if="isIrrResourceList">Resources</h1>
            <h1 v-else-if="!isTemplate && !specificUser" class="color-resource-dark"></h1>
            <h1 v-else-if="!isTemplate && specificUser" class="color-resource-dark">Resources owned by user {{specificUser['email']}} - id #{{specificUser['id']}}</h1>
            <h1 v-else-if="!specificUser"></h1>
            <h1 v-else>Templates owned by user {{specificUser['email']}} - id #{{specificUser['id']}}</h1>
          </div>
          <div class="col-4">
            <div v-html="paginateHtml" class="d-flex justify-content-center"></div>
          </div>
        </div>


        <div class="card-text">
          <div v-if="!isIrrResourceList">  <!--for listings on IRR pages there are no buttons -->
            <!-- buttons for resources -->
            <div v-if="!isTemplate" class="row ml-3 mt-4">
              <a v-if="filter == 'all'" :href="createFilterButtonURL('resource', 'all')" class="btn btn-resource btn-sm mt-auto mr-3 mb-2">All ({{resourceInfo.total}})</a>
              <a v-else :href="createFilterButtonURL('resource', 'all')" class="btn btn-unselected btn-sm mt-auto mr-3 mb-2">All ({{resourceInfo.total}})</a>
              <a v-if="filter == 'published'" :href="createFilterButtonURL('resource', 'published')" class="btn btn-resource btn-sm mt-auto mr-3 mb-2">Published ({{resourceInfo.numPublished}})</a>
              <a v-else :href="createFilterButtonURL('resource', 'published')" class="btn btn-unselected btn-sm mt-auto mr-3 mb-2">Published ({{resourceInfo.numPublished}})</a>
              <a v-if="filter == 'unpublished'" :href="createFilterButtonURL('resource', 'unpublished')" class="btn btn-resource btn-sm mt-auto mr-3 mb-2">Unpublished ({{resourceInfo.numUnpublished}})</a>
              <a v-else :href="createFilterButtonURL('resource', 'unpublished')" class="btn btn-unselected btn-sm mt-auto mr-3 mb-2">Unpublished ({{resourceInfo.numUnpublished}})</a>
              <a v-if="filter == 'pending'" :href="createFilterButtonURL('resource', 'pending')" class="btn btn-resource btn-sm mt-auto mr-3 mb-2">Pending ({{resourceInfo.pendingPublishRequests}})</a>
              <a v-else :href="createFilterButtonURL('resource', 'pending')" class="btn btn-unselected btn-sm mt-auto mr-3 mb-2">Pending ({{resourceInfo.pendingPublishRequests}})</a>
              <a v-if="filter == 'denied'" :href="createFilterButtonURL('resource', 'denied')" class="btn btn-resource btn-sm mt-auto mr-3 mb-2">Denied ({{resourceInfo.deniedPublishRequests}})</a>
              <a v-else :href="createFilterButtonURL('resource', 'denied')" class="btn btn-unselected btn-sm mt-auto mr-3 mb-2">Denied ({{resourceInfo.deniedPublishRequests}})</a>
            </div>
            <!-- buttons for templates -->
            <div v-else class="row ml-3 mt-4">
              <a v-if="filter == 'all'" :href="createFilterButtonURL('template', 'all')" class="btn btn-resource btn-sm mt-auto mr-3 mb-2">All ({{resourceInfo.total}})</a>
              <a v-else :href="createFilterButtonURL('template', 'all')" class="btn btn-unselected btn-sm mt-auto mr-3 mb-2">All ({{resourceInfo.total}})</a>
            </div>
          </div>

          <div class="card bg-color-light border-dark mt-4">
            <table class="table table-sm table-borderless table-hover">
              <thead class="border-bottom-dark">
                <tr v-if="!isTemplate">
                  <th scope="col" class="larger pl-3">Name</th>
                  <th scope="col" class="larger d-none d-md-table-cell">Data Collected</th>  <!-- type of device heading-->
                  <th scope="col" class="larger d-none d-md-table-cell">Privacy Requests Management</th>
                  <th scope="col" class="larger d-none d-md-table-cell">Registries</th>
                  <th scope="col" class="larger">Status</th>
                  <th v-if="route == 'index'" scope="col" class="larger"></th> <!-- Column for actions that can be taken -->
                  <th v-if="route != 'index' && isIrrResourceList" scope="col" class="larger">Contributor</th>
                  <th v-if="route != 'index' && isIrrResourceList && permissions.currentPermissions.IRR_UNPUBLISH_RESOURCE" scope="col" class="larger">Unpublish</th>
                </tr>
                <tr v-else>
                  <th scope="col" class="larger pl-3">Name</th>
                  <th v-if="route == 'index'" scope="col" class="larger"></th> <!-- Column for actions that can be taken -->
                </tr>
              </thead>
              <tbody>
                <!-- iterate through {{numResourcesToDisplay}} number of resources  -->
                <tr v-if="numResourcesToDisplay_adjusted" v-for="n in numResourcesToDisplay_adjusted">
                  <th v-if="!isTemplate" class="pl-3"><a :href="createResourceURL(resources[n-1].id)">{{ resources[n-1].name }}</a></th>  <!-- name with link to resource page -->
                  <th v-else class="pl-3"><a :href="createTemplateURL(resources[n-1].id)">{{ resources[n-1].name }}</a></th>  <!-- name with link to template page -->
                  <th v-if="!isTemplate" class="d-none d-md-table-cell">  <!-- type of device -->
                    <div v-for="dataCollectType in resources[n-1].data_collect_types">
                      {{ resourceFramework.data['data_collect_types_' + dataCollectType].display_value }}
                    </div>
                  </th>
                  <th v-if="!isTemplate" class="d-none d-md-table-cell">{{ formatPrivacyOptionsDisplay(resources[n-1]) }}</th>
                  <th v-if="!isTemplate" class="d-none d-md-table-cell" v-html="createIrrList(resources[n-1].associatedIrrs)"></th>
                  <th v-if="!isTemplate" v-html="getStatusHtml(resources[n-1])"></th>  <!-- publish status -->
                  <th v-if="route == 'index' && !isTemplate">
                    <div class="dropdown dropleft">
                      <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="actionsDropdownButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" v-on:click="$emit('change-active-resource', n-1)" href="javascript:void(0)">Show on map</a>
                        <a class="dropdown-item" :href="createResourceURL(resources[n-1].id)">View</a>
                        <a class="dropdown-item" :href="createResourceEditURL(resources[n-1].id)">Edit</a>
                        <a class="dropdown-item" :href="createResourcePublishURL(resources[n-1].id)">(Un)Publishing</a>
                        <a class="dropdown-item" :href="createResourceDeleteURL(resources[n-1].id)">Delete</a>
                        <a v-if="permissions.currentPermissions.SYS_TRANSFER_RESOURCE || resources[n-1].isOwner" class="dropdown-item" :href="createResourceTransferURL(resources[n-1].id)">Transfer Ownership</a>
                        <a v-if="resources[n-1].isOwner" class="dropdown-item" href="javascript:void(0)" @click="openCopyAsTemplateModal(resources[n-1])">Copy as Template</a>
                      </div>
                    </div>
                  </th>
                  <th v-else-if="!isIrrResourceList">
                    <div class="dropdown dropleft">
                      <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="actionsDropdownButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" :href="createTemplateURL(resources[n-1].id)">View</a>
                        <a class="dropdown-item" :href="createTemplateEditURL(resources[n-1].id)">Edit</a>
                        <a class="dropdown-item" :href="createResourceFromTemplateURL(resources[n-1].id)">Create Resource Instance</a>
                      </div>
                    </div>
                  </th>
                  <!-- <th v-else><a :href="createUserURL(resources[n-1].user_id)">{{ resources[n-1].user_display_name }}</a></th> -->
                  <th v-else>{{ resources[n-1].user_display_name }}</th>  <!-- resource owner name(link to user page) -->
                  <th v-if="route != 'index' && !isTemplate && isIrrResourceList && permissions.currentPermissions.IRR_UNPUBLISH_RESOURCE">
                    <button @click="assignUnpublishResource(n-1)" class="btn btn-danger btn-sm" type="button" id="unpublishButton" data-toggle="modal" data-target="#unpublishResourceModal" aria-disabled="true">
                      Unpublish
                    </button>
                  </th>
                </tr>
              </tbody>
            </table>
            <div v-html="paginateHtml" class="d-flex justify-content-center"></div>
          </div>


        </div>
      </div>
    </div>

  </div>
</template>

<script>
    export default {
      props: {
        route: String,
        currentIrr: Object,
        permissions: Object,
        resources: Array,
        resourceFramework: Object,
        numResourcesToDisplay: Number,
        resourceInfo: {
          default () {
            return {
              total: 0,
              numPublished: 0,
              numPublications: 0,
              pendingPublishRequests: 0,
              deniedPublishRequests: 0
            }
          },
          type: Object
        },
        isTemplate: [Boolean, Number],
        isIrrResourceList: {
          default: false,
          type: [Boolean, Number]
        },
        paginateHtml: String,
        filter: String,
        specificUser: [Object, Array, Boolean],
        csrf_token: {
          type: String,
          default: '',
        },
      },
      data: function() {
        return {
          numResourcesToDisplay_adjusted: 0,
          unpublishResource: null,
          copyAsTemplateResource: null,
          templateCopyName: '',
          templateCopyNameError: '',
          templateCopyInProgress: false,
          templateCopySuccessMessage: '',
          templateCopyId: null,
        }
      },
      methods: {
        assignUnpublishResource: function(index) {
          this.unpublishResource = this.resources[index];
        },
        getUnpublishUrl: function() {
          if(!this.currentIrr || !this.unpublishResource) {
            return "#";
          } else {
            return '/irr/' + this.currentIrr.id + '/unpublishresource/' + this.unpublishResource.id;
          }
        },
        submitUnpublish: function() {
          var url = this.getUnpublishUrl();
          if (url === '#' || !url || !this.csrf_token) {
            return;
          }
          var form = document.createElement('form');
          form.method = 'POST';
          form.action = url;
          var token = document.createElement('input');
          token.type = 'hidden';
          token.name = '_token';
          token.value = this.csrf_token;
          form.appendChild(token);
          document.body.appendChild(form);
          form.submit();
        },
        openCopyAsTemplateModal: function(resource) {
          this.copyAsTemplateResource = resource;
          this.templateCopyName = '';
          this.templateCopyNameError = '';
          this.templateCopySuccessMessage = '';
          this.templateCopyId = null;
          $('#listCopyToTemplateModal').modal('show');
        },
        submitCopyAsTemplate: function() {
          if (!this.copyAsTemplateResource) {
            return;
          }

          var templateName = (this.templateCopyName || '').trim();
          if (!templateName) {
            this.templateCopyNameError = 'Please enter a name for the template.';
            return;
          }

          this.templateCopyNameError = '';
          this.templateCopyInProgress = true;
          var _this = this;

          $.ajax({
            url: '/resource/copy-as-template',
            method: 'POST',
            data: {
              _templateCopyName: templateName,
              _sourceResourceId: this.copyAsTemplateResource.id,
            },
            headers: { 'X-CSRF-TOKEN': this.csrf_token },
            success: function(response) {
              _this.templateCopyInProgress = false;
              $('#listCopyToTemplateModal').modal('hide');
              _this.templateCopyName = '';
              _this.copyAsTemplateResource = null;
              _this.templateCopySuccessMessage = response.message;
              _this.templateCopyId = response.templateId || null;
            },
            error: function(xhr) {
              _this.templateCopyInProgress = false;
              if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) {
                var errors = xhr.responseJSON.errors;
                if (errors._templateCopyName && errors._templateCopyName.length) {
                  _this.templateCopyNameError = errors._templateCopyName[0];
                } else {
                  var firstError = null;
                  for (var field in errors) {
                    if (errors.hasOwnProperty(field) && errors[field] && errors[field].length) {
                      firstError = errors[field][0];
                      break;
                    }
                  }
                  _this.templateCopyNameError = firstError || 'Unable to create template. Please check your resource data.';
                }
              } else {
                _this.templateCopyNameError = 'An error occurred while creating the template. Please try again.';
              }
            }
          });
        },
        createResourceURL: function(resourceID) {
          return '/resource/' + resourceID;
        },
        createTemplateURL: function(resourceID) {
          return '/resource/' + resourceID;
        },
        createResourceEditURL: function(resourceID) {
          return '/resource/' + resourceID + "/edit";
        },
        createResourceDeleteURL: function(resourceID) {
          return '/resource/' + resourceID + "/?delete=1";
        },
        createResourceTransferURL: function(resourceID) {
          return '/resource/' + resourceID + "/?transfer=1";
        },
        createTemplateEditURL: function(resourceID) {
          return '/resource/' + resourceID + "/edit";
        },
        createResourceFromTemplateURL: function(resourceID) {
          return '/template/' + resourceID + '/load/';
        },
        createResourcePublishURL: function(resourceID) {
          return '/resource/' + resourceID + "/publish";
        },
        createUserURL: function(userID) {
          return '/user/' + userID;
        },
        createFilterButtonURL: function(type, filter) {
          if(type == 'resource') {
            var url = '/resource';
          } else {
            var url = '/template';
          }

          if(filter != 'all') {
            url += '/index/' + filter;
          }

          if(this.specificUser) {
            url += '?userid=' + this.specificUser.id;
          }

          return url + '#list';
        },
        //shorten a description string for display
        shortenDescription: function(desc) {
          if(desc.length < 101) {
            return desc;
          }
          return desc.substring(0, 97) + '...';
        },
        formatDate: function(ts) {
          var date = new Date(ts);
          var day = date.getDate();
          var month = date.getMonth() + 1;
          var year = date.getFullYear();

          day = '0' + day;
          month = '0' + month;
          day = (day.length == 2) ? day : day.slice(1);
          month = (month.length == 2) ? month : month.slice(1);

          return year + '-' + month + '-' + day;
        },
        createIrrList: function(irrs) {
          var html = '';
          for(var i=0; i<irrs.length; i++) {
            html += '<a href="/irr/' + irrs[i].id + '/" >' + irrs[i].name + '</a>';
            if(i+1 <irrs.length) { html += '<br>'; }
          }
          return html;
        },
        getStatusHtml: function(resource) {
          if(resource.associatedIrrs.length) {
            var html = 'Published';
          } else {
            var html = 'Unpublished';
          }
          return html;
        },
        /**
         * Mirrors ResourcesController::formatResourceForView() privacy_management_option inference.
         */
        formatPrivacyOptionsDisplay: function(resource) {
          var pmo = resource.privacy_management_option;
          if (pmo === 'portal') {
            return 'Own Portal/Website';
          }
          if (pmo === 'email') {
            return 'Via Email';
          }
          if (pmo === 'agent') {
            return 'Data Rights Protocol';
          }
          return 'None';
        },
      },
      created() {
        this.numResourcesToDisplay_adjusted = Math.min(this.numResourcesToDisplay, this.resources.length);
      },
      mounted() {
        //
      }
    }
</script>
